module.exports = {
  name: 'UserAuth',
  data: () => ({
    userId: null,
    userInfo: null
  }),
  methods: {
    load() {},
    onUserChanged() {}
  },
  mounted() {
    let unsubscribe = this.$auth.onAuthStateChanged(user => {
      unsubscribe();
      if (user) {
        this.userId = user.uid;
        this.userInfo = user;
        this.load();
      }
      this.onUserChanged();
    })
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/UserAuth.js
// module id = 3g3v
// module chunks = 0